import { useCallback, useState } from 'react'
import { numberFormat } from 'shared/util'

import { Loading } from 'components/controls/loading'
import { ErrorInfo } from 'components/controls/errorInfo'

import { useGroupConfigContainer } from './container'

import { SearchTableBody } from 'components/controls/searchTable'
import { ValueSpan } from 'components/controls/valueSpan'

import { GroupResult } from 'interface/user/group'

import { ConfigureListHeader } from '../components/header'
import { EditGroupDialog } from 'features/user/group/dialog/edit'
import { AddGroupDialog } from 'features/user/group/dialog/add'

import { Stack } from '@mui/material'

export const ConfigureGroupPage = () => {
	const [modal, setModal] = useState<{
		mode: "addGroup" | "editGroup"
		group?: GroupResult
  } | null>(null)

  const {
    loading,
    error,
    groupList,
    searchWord,
    setSearchWord,
    onAddGroup,
    onEditGroup,
    onDeleteGroup
  } = useGroupConfigContainer()

	const closeModal = useCallback(
		() => setModal(null),
		[setModal]
	)
	const openAddGroupDialog = useCallback(
		() => setModal({ mode: "addGroup" }),
		[setModal]
	)
	const openEditGroupDialog = useCallback(
		(group: GroupResult) => setModal({ mode: "editGroup", group }),
		[setModal]
	)
  return (
    <>
      {loading && <Loading/>}

      <ConfigureListHeader
        searchWord={searchWord}
        setSearchWord={setSearchWord}
        openAddButtonLabel="新しいグループを追加"
        openAddDialog={openAddGroupDialog}
      >
        <ValueSpan text={numberFormat(groupList?.length, '')} suffix='グループ'/>
      </ConfigureListHeader>

      <Stack direction="column" spacing={1}>
        {error && <ErrorInfo error={error}/>}
      </Stack>

      {groupList && (
        <SearchTableBody<GroupResult>
          list={groupList}
          columnList={[
            { label: 'グループ名', value: (r) => r.groupName, expand: true },
            { label: 'ユーザー数', value: (r) => `${r.user?.length ?? 0} 名`, align: 'right' },
          ]}
          onClickRow={openEditGroupDialog}
        />
      )}

      {modal?.mode === 'addGroup' ? (
        <AddGroupDialog
          onAddGroup={onAddGroup}
          onClose={closeModal}
        />
      ) : (modal?.mode === 'editGroup' && modal?.group) ? (
        <EditGroupDialog
          group={modal.group}
          onEditGroup={onEditGroup}
          onDeleteGroup={onDeleteGroup}
          onClose={closeModal}
        />
      ) : (
        <></>
      )}
    </>
  )
}
